



































































































































































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { UiLanguageList } from '@/types'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import { hexToRgba } from '@/services/hex-to-rgba'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { KommissionResponse, ResponseBase } from '@/types/service-response'
import {
  COMPANY_FETCH_COMPANY_STRUCTURE, COPY_COMMISSION,
  CREATE_COMMISSION,
  DELETE_PRODUCT, FETCH_COMMISSION_DATA, UPDATE_COMMISSION
} from '@/store/action-types'
import CommissionAdditionalFields from '@/components/master-data/commissions/CommissionAdditionalFields.vue'
import CommissionNotes from '@/components/master-data/commissions/CommissionNotes.vue'
import CommissionSubscriptions from '@/components/master-data/commissions/CommissionSubscriptions.vue'
import Documents from '@/components/Documents.vue'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel, DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import moment from 'moment'
import { AddKommissionRequest, UpdateKommissionRequest } from '@/types/payload'
import { SearchCommission } from '@/model/commissions/SearchCommission'
import { Employee } from '@/model/companyStructure/Employee'
import { CommissionGroup } from '@/model/commissions/CommissionGroup'
import CreateProjectAddressSearch from '@/components/project/CreateProjectAddressSearch.vue'
import { SearchAddressEmployee } from '@/model/addresses/SearchAddressEmployee'
import { Commission } from '@/model/commissions/Commission'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}
class Search extends KeyAction {}

interface ComponentData {
  tableHeight: string
  activeTab: number
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  showDeleteDialog: boolean
  loading: boolean
  saveLoading: boolean
  rules: Array<Function>
  dateRules: Function[]

  selectedCommissionId: number | null
  commissionIdIndex: number
  selectedCommission: Commission | null
  isEdit: boolean

  showSearchDialog: boolean
  addressId: string | null
  addressLabel: string

  kommissionArt: string | null
  kommissionNumber: string
  employeeList: Employee[]
  sachbearbeiter: number | null
  bezeichnung: string
  menu1: boolean
  menu2: boolean
  start: string | null
  startFormatted: string | null
  end: string | null
  endFormatted: string | null
  fach: string
  bemerkungen: string

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'CommissionWindow',

  components: {
    CommissionAdditionalFields,
    CommissionSubscriptions,
    Documents,
    CommissionNotes,
    AgGridVue,
    ProgressCircular,
    CreateProjectAddressSearch,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    DeleteDialog
  },

  props: {
    showDialog: Boolean,
    commissionArtList: Array as () => CommissionGroup[],
    commissionIdList: Array as () => number[],
    commissionList: Array as () => SearchCommission[],
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      activeTab: 0,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      showDeleteDialog: false,
      loading: false,
      saveLoading: false,
      rules: [(value: any): boolean | string => !!value || ''],
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || '' : true : true
        },

        (value: string) => {
          return !!value
        },

        () => {
          //@ts-ignore
          return this.isDatesValid
        }
      ],

      selectedCommissionId: null,
      commissionIdIndex: 0,
      selectedCommission: null,
      isEdit: false,

      showSearchDialog: false,
      addressId: null,
      addressLabel: '',

      kommissionArt: null,
      kommissionNumber: '',
      employeeList: [],
      sachbearbeiter: null,
      bezeichnung: '',
      menu1: false,
      menu2: false,
      start: null,
      startFormatted: null,
      end: null,
      endFormatted: null,
      fach: '',
      bemerkungen: '',

      keyActions: []
    }
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    getCommissionTitle (): string {
      if(this.kommissionNumber || this.bezeichnung) {
        return `${this.kommissionNumber ? this.kommissionNumber : ''} ${this.bezeichnung ? this.bezeichnung : ''}`
      } else {
        return ''
      }
    },

    isCommissionBeforeDisabled (): boolean {
      return this.commissionIdIndex === 0 || this.commissionIdList.length === 0
    },

    isCommissionAfterDisabled (): boolean {
      return this.commissionIdIndex === this.commissionIdList.length -1 || this.commissionIdList.length === 0
    },


    filteredCommissionList (): SearchCommission[] {
      return this.commissionList.filter((item: SearchCommission) => this.commissionIdList.includes(item.id))
    },

    isDatesValid (): boolean {
      if(this.start && moment(this.start, 'YYYY-MM-DD').isValid() && this.end && moment(this.end, 'YYYY-MM-DD').isValid()) {
        return this.end && moment(this.end, 'YYYY-MM-DD').isBefore(moment(this.start, 'YYYY-MM-DD')) ? false : true

      } else {
        return true
      }
    }
  },

  watch: {
    selectedCommissionId (newVal: number): void {
      const form: any = this.$refs['form']
      form.resetValidation()
      if(newVal !== 0) {
        this.isEdit = false
        this.fetchCommissionData()
      } else {
        this.activeTab = 0
        this.setData()
      }
    },

    activeTab (newVal: number): void {
      if (this.$route.path === '/commissions') {
        let data: any = this.getRouteData()
        data.commissionTab = newVal
        this.$router.push({ name: 'CommissionsSearch', query: { data: JSON.stringify(data) } })
      }
      if(newVal === 0) {
        //@ts-ignore
        setTimeout(() => { this.$refs.dataGrid.instance.refresh() }, 0)
        setTimeout(() => { this.onResize() }, 0)
      }
    },

    startFormatted (newVal: string | null): void {
      if(newVal && moment(newVal, 'DD.MM.YYYY').isValid()) {
        this.start = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.start = null
      }
    },

    endFormatted (newVal: string | null): void {
      if(newVal && moment(newVal, 'DD.MM.YYYY').isValid()) {
        this.end = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.end = null
      }
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | Search | null): boolean {
      if(action instanceof Create && this.activeTab === 0 || this.activeTab === 1) {
        return !this.isEdit
      } else if(action instanceof Edit && this.activeTab === 0 || this.activeTab === 1) {
        return !!this.selectedCommissionId || !this.isEdit
      } else if(action instanceof Delete && this.activeTab === 0 || this.activeTab === 1) {
        return !!this.selectedCommissionId || !this.isEdit
      } else if(action instanceof Search) {
        return true
      } else {
        return false
      }
    },

    formatDate(item: string): string {
      return moment(item, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(item, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY') : ''
    },

    onDateStartChange (date: string): void {
      this.startFormatted = moment(date).format('DD.MM.YYYY')
    },

    onDateEndChange (date: string): void {
      this.endFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurStart (): void {
      this.startFormatted = this.start && moment(this.start).isValid() ? moment(this.start).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onBlurEnd (): void {
      this.endFormatted = this.end && moment(this.end).isValid() ? moment(this.end).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onSearchAddressClick (): void {
      if(this.isEdit || this.selectedCommissionId === 0) {
        this.showSearchDialog = true
      }
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    onSelectedAddress (data: SearchAddress): void {
      this.closeSearchDialog()
      this.addressLabel = data.genAdresse ? data.genAdresse : ''
      this.addressId = `A${data.id}`
    },

    selectedAddressEmployee (data: SearchAddressEmployee): void {
      this.closeSearchDialog()
      this.addressLabel = data.genAdresse ? data.genAdresse : ''
      this.addressId = `S${data.sachbearbeiterID}`
    },

    onAddCommissionClick (): void {
      this.create()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.isEdit = true
      this.commissionIdIndex = 0
      this.selectedCommissionId = 0
      this.selectedCommission = null
      this.$emit('startCreate')
    },

    onEditCommissionClick (): void {
      this.update()
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.activeTab = 0
      this.isEdit = true

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 100)
    },

    onDeleteCommissionClick (): void {
      this.delete()
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.showDeleteDialog = true
    },

    onCommissionBeforeClick (): void {
      this.commissionIdIndex -= 1
      this.selectedCommissionId = this.commissionIdList[this.commissionIdIndex]
      if (this.$route.path === '/commissions') {
        let data: any = this.getRouteData()
        data.commissionIdIndex = this.commissionIdIndex
        this.$router.push({ name: 'CommissionsSearch', query: { data: JSON.stringify(data) } })
      }
    },

    onCommissionAfterClick (): void {
        this.commissionIdIndex += 1
        this.selectedCommissionId = this.commissionIdList[this.commissionIdIndex]
      if (this.$route.path === '/commissions') {
        let data: any = this.getRouteData()
        data.commissionIdIndex = this.commissionIdIndex
        this.$router.push({ name: 'CommissionsSearch', query: { data: JSON.stringify(data) } })
      }
    },

    onSearchClick (): void {
      this.search()
    },

    search (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.$emit('close')
    },

    onCloseDialog (): void {
      this.$emit('close')
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.showDeleteDialog = false
      this.deleteCommission()
    },

    async deleteCommission (): Promise<void> {
      try {
        this.loading = true
        const response: ResponseBase = await this.$store.dispatch(DELETE_PRODUCT, this.selectedCommissionId)
        if (!response.IsError) {
          this.$emit('commissionDeleted', this.selectedCommissionId!)
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.loading = false
      }
    },

    onCancelClick (): void {
      this.isEdit = false
      if(this.selectedCommissionId === 0) {
        this.onCloseDialog()
      } else {
        this.setData()
      }
    },

    async onCopyClick (): Promise<void> {
      try {
        this.saveLoading = true
        const response: KommissionResponse = await this.$store.dispatch(COPY_COMMISSION, this.selectedCommissionId)
        if (!response.IsError && response.Kommission) {
          const newCommission: SearchCommission = Commission.createFromResponse(response.Kommission)
          this.$emit('commissionCopy', newCommission)
          const foundCommission: SearchCommission | undefined = this.filteredCommissionList.find((item: SearchCommission) => item.id === newCommission.id)
          if(foundCommission) {
            this.commissionIdIndex = this.filteredCommissionList.indexOf(foundCommission)
            this.selectedCommissionId = foundCommission.id
          }
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.saveLoading = false
      }
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if(form.validate()) {
        if (this.isEdit && this.selectedCommissionId && this.selectedCommissionId !== 0) {
          this.updateCommission()
        } else {
          this.createCommission()
        }
      }
    },

    async createCommission (): Promise<void> {
      const payload: AddKommissionRequest = {
        Sprache: this.selectedLanguageId,
        Nummer: this.kommissionNumber,
        Bezeichnung: this.bezeichnung,
        Start: this.start!,
        Termin: this.end!,
        Adresse: this.addressId!,
        Sachbearbeiter: this.sachbearbeiter!,
        Fach: this.fach,
        Bemerkungen: this.bemerkungen,
        Art: parseInt(this.kommissionArt!)
      }

      try {
        this.saveLoading = true
        const response: KommissionResponse = await this.$store.dispatch(CREATE_COMMISSION, payload)
        if (!response.IsError && response.Kommission) {
          const newCommission: SearchCommission = Commission.createFromResponse(response.Kommission)
          this.$emit('commissionCreated', newCommission)
          this.selectedCommissionId = newCommission.id
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.saveLoading = false
      }
    },

    async updateCommission (): Promise<void> {
      const payload: UpdateKommissionRequest = {
        Kommission: this.selectedCommissionId!,
        Sprache: this.selectedLanguageId,
        Nummer: this.kommissionNumber,
        Bezeichnung: this.bezeichnung,
        Start: this.start!,
        Termin: this.end!,
        Adresse: this.addressId!,
        Sachbearbeiter: this.sachbearbeiter!,
        Fach: this.fach,
        Bemerkungen: this.bemerkungen,
        Art: parseInt(this.kommissionArt!)
      }

      try {
        this.saveLoading = true
        const response: KommissionResponse = await this.$store.dispatch(UPDATE_COMMISSION, payload)
        if (!response.IsError && response.Kommission) {
          this.isEdit = false
          this.$emit('commissionEdited')
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.saveLoading = false
      }
    },

    onRowClick (rowData: any): void {
      this.commissionIdIndex = this.filteredCommissionList.indexOf(rowData.data)
      this.selectedCommissionId = rowData.data.id
      //this.fetchCommissionData()
      //this.selectedCommission = this.filteredCommissionList[this.commissionIdIndex]
      if (this.$route.path === '/commissions') {
        let data: any = this.getRouteData()
        data.commissionIdIndex = this.commissionIdIndex
        this.$router.push({ name: 'CommissionsSearch', query: { data: JSON.stringify(data) } })
      }
    },

    onResize (): void {
      if(this.$refs.formSection && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.formSection as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 184px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    setData (): void {
      //const foundCommission: SearchCommission | undefined = this.commissionList.find((item: SearchCommission) => item.id === this.selectedCommissionId)
      if(this.selectedCommission) {
        //this.selectedCommission = foundCommission

        this.kommissionArt = this.selectedCommission.art
        this.kommissionNumber = this.selectedCommission.kommissionNummer
        this.sachbearbeiter = this.selectedCommission.sachbearbeiterID
        this.bezeichnung = this.selectedCommission.bezeichnung
        this.start = this.selectedCommission.start && moment(this.selectedCommission.start, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(this.selectedCommission.start, 'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : null
        this.end = this.selectedCommission.end && moment(this.selectedCommission.end, 'DD.MM.YYYY HH:mm:ss').isValid() ? moment(this.selectedCommission.end, 'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD') : null
        this.startFormatted = this.start ? moment(this.start).format('DD.MM.YYYY') : null
        this.endFormatted = this.end ? moment(this.end).format('DD.MM.YYYY') : null
        this.addressId = this.selectedCommission.aSBAdresse ? this.selectedCommission.aSBAdresse : null
        this.addressLabel = this.selectedCommission.genAdresse ? this.selectedCommission.genAdresse : ''
        this.fach = this.selectedCommission.fach
        this.bemerkungen = this.selectedCommission.bemerkungen
      } else {
        this.showSearchDialog = true
        this.kommissionArt = null
        this.kommissionNumber = ''
        this.sachbearbeiter = null
        this.bezeichnung = ''
        this.start = null
        this.end = null
        this.startFormatted = null
        this.endFormatted = null
        this.addressLabel = ''
        this.fach = ''
        this.bemerkungen = ''
      }

      if(this.filteredCommissionList.length > 0 && this.filteredCommissionList[this.commissionIdIndex]) {
        //@ts-ignore
        setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.filteredCommissionList[this.commissionIdIndex].id])}, 100)
      }
    },

    async fetchCommissionData (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_COMMISSION_DATA, this.selectedCommissionId)
        this.loading = false
        if(response && !response.IsError && response.Kommission) {
          this.selectedCommission = Commission.createFromResponse(response.Kommission)
          this.setData()
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchEmployeeList (): Promise<void> {
      if((this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList.length > 0) {
        this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList
      } else {
        await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
        this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if (this.$route.path === '/commissions') {
        this.commissionIdIndex = data && data.commissionIdIndex ? data.commissionIdIndex : 0
        if (this.commissionIdList[this.commissionIdIndex]) {
          this.selectedCommissionId = this.commissionIdList[this.commissionIdIndex]
        } else {
          this.selectedCommissionId = this.commissionIdList[0]
        }
        this.activeTab = data.commissionTab
      }
    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
      new Search(KeyActionEnum.search, this.search, this.resolver, null)
    ]
  },

  mounted (): void {
    window.addEventListener('keydown', this.onKeydown)
    if(this.selectedCommissionId) {
      this.fetchCommissionData()
    }
    this.fetchEmployeeList()
    this.setDataFromRoute()
    this.onResize()
  },



  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
